interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const PlusIcon: React.FC<IconProps> = ({ className, theme= 'light' }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			fill={theme === 'light' ? "#131313" : '#fff'}
			viewBox="0 0 14 15"
		>
			<path fill={theme === 'light' ? "#131313" : '#fff'} d="M14 8.864H8v6H6v-6H0v-2h6v-6h2v6h6v2z"></path>
		</svg>
	)
}
